module.exports = __webpack_public_path__ + "static/36gde-d5e588f0be09838dd5ce6cd1511f9774.gif";